// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: true,
	entorno: 'PRODUCCION',
	googleAnalyticsKey: 'UA-102799820-23',
	nroAplicacion: 143,
	api_url: 'https://api.cnrt.gob.ar/portalempresa/v1',
	api_dut_url: 'https://api.cnrt.gob.ar/portalempresa',
	api_seop_url: 'https://api.cnrt.gob.ar/seop/doc',
	georef_api_url: 'https://api.cnrt.gob.ar/georef/api/v1',
	log_level: 2,
	current_idp: 'hydra',
	faqs_url: 'https://api.cnrt.gob.ar/faqs',
	faqs_category_id: 21,
	gep_url: 'https://gep.cnrt.gob.ar',
	linti_url: 'https://linti.seguridadvial.gob.ar/lintidigital/',
	authConfig: {
		responseType: 'code',
		issuer: 'https://api.cnrt.gob.ar/oidc/',
		redirectUri: 'https://portalempresas.cnrt.gob.ar',
		logoutUrl: 'https://api.cnrt.gob.ar/oidc/oauth2/auth/sessions/login/revoke',
		clientId: 'portalempresas',
		scope: 'openid offline',
		strictDiscoveryDocumentValidation: false,
		disableAtHashCheck: true,
		customUserinfoEndpoint: 'https://api.cnrt.gob.ar/sia/api/v1/usuarios/actual?nroAplicacion=143',
	},
	id_dispositivo: 1,
	url_dut_1: 'https://portalempresas.cnrt.gob.ar',
	rolesCuadroHorario: ['ADMIN_EMPRESA_CH'],
};
